package com.example.mystybag.core.model

import com.example.mystybag.core.logic.base.DialogConfig
import com.example.mystybag.core.logic.helpers.DialogResult
import kotlinx.coroutines.CancellableContinuation

data class PendingDialog(
    val config      : DialogConfig,
    val continuation: CancellableContinuation<DialogResult>
)
